import gifImg from "../ViewMedia/images/gif.png";
import pngImg from "../ViewMedia/images/png.png";
import jpegImg from "../ViewMedia/images/jpeg.png";
import movImg from "../ViewMedia/images//mov.png";
import mpegImg from "../ViewMedia/images/mpeg.png";
import pdfImg from "../ViewMedia/images/pdf.png";
import mp4Img from "../ViewMedia/images/mp4.png";

export const imgData = [
  {
    id: "gif",
    src: gifImg,
  },
  {
    id: "mp4",
    src: mp4Img,
  },
  {
    id: "png",
    src: pngImg,
  },
  {
    id: "jpeg",
    src: jpegImg,
  },
  {
    id: "jpg",
    src: jpegImg,
  },
  {
    id: "tiff",
    src: jpegImg,
  },
  {
    id: "psd",
    src: jpegImg,
  },
  {
    id: "eps",
    src: jpegImg,
  },
  {
    id: "bmp",
    src: jpegImg,
  },
  {
    id: "erf",
    src: jpegImg,
  },
  {
    id: "x-matroska",
    src: movImg,
  },
  {
    id: "mkv",
    src: movImg,
  },
  {
    id: "wmv",
    src: movImg,
  },
  {
    id: "avi",
    src: movImg,
  },
  {
    id: "webm",
    src: movImg,
  },
  {
    id: "hevc",
    src: movImg,
  },
  {
    id: "flv",
    src: movImg,
  },
  {
    id: "mov",
    src: movImg,
  },

  {
    id: "quicktime",
    src: movImg,
  },
  {
    id: "pdf",
    src: pdfImg,
  },
  {
    id: "mpeg",
    src: mpegImg,
  },
];
